import { createStandaloneToast } from '@chakra-ui/react';

/**
 * App-wide standalone toast instance.
 *
 * Relocated out of `src/ui/toast` into the shared lib layer so lower layers
 * (e.g. the `store/flash` slice) can trigger toasts without a store -> ui
 * boundary violation. `src/ui/toast` re-exports these for existing callers.
 */
const { ToastContainer, toast } = createStandaloneToast();

export { toast, ToastContainer };
